import {ApplePlatform} from '../../types';

export const simulatorDestinationMap: Record<ApplePlatform, string> = {
  ios: 'iOS Simulator',
  macos: 'macOS',
  visionos: 'visionOS Simulator',
  tvos: 'tvOS Simulator',
};
